import React, { useMemo } from 'react';
import { getCdnHost } from '@/config/apiHosts';
import { Typography } from 'antd';
// import intl from 'react-intl-universal';
import { getClientVersion } from '@/utils/monitor';
import intl from 'react-intl-universal';

import styles from './index.module.scss';

const { Paragraph } = Typography;

const Index = () => {
  const appVersion = 'v1.15.5';
  const copyright = '@2021 wangyu.All Rights Reserved.';

  const clientVersion = useMemo(() => {
    if (typeof window.electron !== 'undefined') {
      return intl.get('help_about_app_version_text', { version: getClientVersion() });
    }
    return intl.get('help_about_web_version_text');
  }, []);

  return (
    <div className={styles.aboutContainer}>
      <div className={styles.logoSection}>
        <img
          src={`${getCdnHost()}/upload/prod/ypms/2023-11-24/1g4EiugdhPRcN0HLHui.svg`}
          alt="YooPMS"
          className={styles.logoImage}
        />
        <div className={styles.version}>{clientVersion}</div>
      </div>

      <div className={styles.footerSection}>
        <Paragraph className={styles.copyright}>{copyright}</Paragraph>
      </div>
    </div>
  );
};

export default Index;
